const summaryData = [
  {
    territory: "Territory 1",
    planOne: 0,
    actualOne: 0,
    balanceOne: 1,
    planTwo: 0,
    planThree: 2,
    balance: 0,
    forecastSepToDec: 0,
    forecast: 1,
    totalForecastTotalPlan: 2,
    totalForecastPlan: 0,
  },
];

const report = [
  {
    territory: "Territory 3",
    partnerName: "KORE",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
  {
    territory: "Territory 5",
    partnerName: "KORE",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
  {
    territory: "Territory 5",
    partnerName: "Ali Abdul Wahab Al Muttawa Commercial Co",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
  {
    territory: "Territory 1",
    partnerName: "Silver Sands",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
  {
    territory: "Territory 1",
    partnerName: "Ali Abdul Wahab Al Muttawa Commercial Co",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
  {
    territory: "Territory 1",
    partnerName: "Silver Sands",
    plan: 4,
    actuals: 3,
    balance: 1,
    percentageOfCompletion: '75.00%',
    percentageBalanceToComplete: '75.00',
  },
]

export { summaryData, report }
